import { withTheme } from '@emotion/react';
import { FC } from 'react';

import { TIconBaseProps } from '../../types/common';

const File: FC<TIconBaseProps> = ({ theme }) => {
  return (
    <svg
      width="30"
      height="34"
      viewBox="0 0 30 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 0H18.5L30 11.5V29C30 31.75 27.75 34 25 34H5C2.25 34 0 31.75 0 29V5C0 2.25 2.25 0 5 0ZM17 3.5V13H26.5L17 3.5ZM7 19C5.90625 19 5 19.9062 5 21C5 22.0938 5.90625 23 7 23H23C24.0938 23 25 22.0938 25 21C25 19.9062 24.0938 19 23 19H7ZM7 26C5.90625 26 5 26.9062 5 28C5 29.0938 5.90625 30 7 30H18C19.0938 30 20 29.0938 20 28C20 26.9062 19.0938 26 18 26H7Z"
        fill={theme.COLORS.BLACK._700}
      />
    </svg>
  );
};

export default withTheme(File);
